import { useEffect } from 'react';
import {
  useCurrentAccountId,
  usePlans,
} from '@zapier/design-system-revenue/src/hooks';
import { PlanV2 } from '@zapier/design-system-revenue/src/types';
import { buildPlanChangeUrl } from '@zapier/design-system-revenue/src/utils';
import { useLink } from '@zapier/common-hooks';

export const UpgradeToTeam = () => {
  const { routeTo } = useLink();
  const { accountId } = useCurrentAccountId();
  const {
    data: { currentAccount, currentPlan, plans },
    isLoading,
  } = usePlans(accountId, { flatPlans: true });
  const teamPlan = (plans as PlanV2[]).find(plan => plan.type === 'Team');

  useEffect(() => {
    if (!isLoading && routeTo && currentAccount && currentPlan && teamPlan) {
      if (currentAccount?.isTeamAccount) {
        routeTo('/app/settings/team');
      } else {
        const changePlanUrl = buildPlanChangeUrl(
          'upgrade',
          currentPlan.name,
          teamPlan.name
        );
        routeTo(changePlanUrl);
      }
    }
  }, [currentAccount, currentPlan, isLoading, teamPlan, routeTo]);

  return null;
};
